import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ResourceTypeLink } from "@evergis/api";

import { CheckboxDescription, TextLine } from "../../DeleteLayer/styled";
import { DeleteDescription } from "../styled";
import { UsersTooltip } from "../../DeleteLayer/UsersTooltip";
import { RequestDependencyInfo, RequestInfoType } from "./RequestInfo";
import { ResourcesTooltip } from "./ResourcesTooltip";
import { DeleteContent } from "./DeleteContent";
import { getUsername } from "../../../../ducks/user";
import { userNamesWithAccess } from "./userNamesWithAccess";
import { useAdditionalParameters } from "../hooks/useAdditionalParameters";
import { ResourcesResolved } from "../resolveResources";
import { DeleteResourcesContentProps } from "../types";

type DeleteTablesDescriptionProps = Pick<DeleteResourcesContentProps, "type" | "toggle" | "checked"> &
  ResourcesResolved;

export const DeleteTablesDescription: FC<DeleteTablesDescriptionProps> = ({
  type,
  tables,
  projects,
  layers,
  checked,
  toggle,
}) => {
  const { t } = useTranslation("dialogs");
  const { showMore, toggleButton } = useAdditionalParameters();

  const currentUser: string = useSelector(getUsername);
  const usersWithDataSourcesAccessNames = useMemo(
    () => userNamesWithAccess(tables, currentUser, t("access.public")),
    [tables, currentUser, t],
  );

  const tablesCount = tables.length;

  if (!tables || tablesCount === 0) {
    return null;
  }

  return (
    <div>
      <span>
        {t("deleteResources.confirmDeletion")}{" "}
        {tablesCount === 1 ? (
          t("deleteResources.dataSourceDeletion")
        ) : (
          <ResourcesTooltip resourceType={ResourceTypeLink.Table} resources={tables} />
        )}
        ?
      </span>
      {toggleButton}
      <DeleteDescription>
        {showMore && (
          <>
            <DeleteContent
              type={type}
              layers={layers}
              tables={tables}
              projects={projects}
              checked={checked}
              toggle={toggle}
            />
            <CheckboxDescription>
              <TextLine>
                <span>
                  {t("deleteResources.usersWithAccess").replace(
                    "{resourceType}",
                    tablesCount > 1 ? t("deleteResources.toDataSources") : t("deleteResources.toDataSource"),
                  )}
                  :&nbsp;
                </span>
                <UsersTooltip users={usersWithDataSourcesAccessNames} />
              </TextLine>
              <TextLine>
                <span>{t("deleteResources.unavailableUsersCatalog")}</span>
              </TextLine>
            </CheckboxDescription>
            <RequestDependencyInfo
              type={RequestInfoType.MapsWithTables}
              projects={projects}
              layers={layers}
              tables={tables}
            />
          </>
        )}
      </DeleteDescription>
    </div>
  );
};
